import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { GET_AEPS_HISTORY_LIST, GET_AEPS_WITHDRAWAL_INQUIRY, FING_PAY_CASH_DEPOSIT_STATUS_API } from '../../Utils/appConstants';
import { getRequest, postRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { DatePicker, Tooltip, Space, Tag } from 'antd';
import { getUTCToLocalDateTimeFormat, queryDate, toDayDate } from '../../Utils/function';
import { aepsStatus } from '../../Utils/Common';
import { toast } from 'react-toastify';
import PropagateLoader from "react-spinners/PropagateLoader";
import { PrinterOutlined } from "@ant-design/icons";

function CashDepositHistory(props) {

    const history = useHistory();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';
    const [searchTransId, setSearchTransId] = useState(null);
    const [searchMobile, setSearchMobile] = useState(null);
    const [searchAadhar, setSearchAadhar] = useState(null);
    const [endDate, setEndDate] = useState(toDayDate());
    const [startDate, setStartDate] = useState(toDayDate());
    const [getData, setData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const [isLimit, setLimit] = useState(limit);

    const columns = [
        {
            name: 'Date Time',
            cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
            width: "200px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Trans ID',
            selector: row => <Tooltip placement="bottom" title={row.transactionId}>{row.transactionId}</Tooltip>,
            width: "180px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Service Name',
            selector: row => <Tooltip placement="bottom" title={row.mode}>{row.mode}</Tooltip>,
            width: "180px",
            headerStyle: () => ({ textAlign: "center", wordWrap: "break-word" }),
        },
        {
            name: 'Bank',
            selector: row => row.bankName || "-",
            width: "130px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Aadhaar',
            selector: row => row.aadhaar ? "XXXXXXXX" + row.aadhaar : "-",
            width: "130px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Mobile',
            selector: row => row.mobile,
            width: "140px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Amount',
            selector: row => row.amount || 0,
            width: "100px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Bank RRN',
            selector: row => row.operatorId,
            width: "130px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Status',
            selector: row => aepsStatus(row.status),
            width: "150px",
            headerStyle: () => ({ textAlign: "center" }),
        },
        {
            name: 'Action',
            selector: (record) => (
                <Space size="middle">
                    {record.status === 0 ? (
                        <Tag
                            color="#5F249F"
                            onClick={() => transactionInquiry(record)}
                            className="pointer"
                        >
                            Inquire
                        </Tag>
                    ) : "-"}
                    <Tooltip title="Print Invoice">
                        <PrinterOutlined
                            className="pointer"
                            style={{ fontSize: "16px", color: "#1890ff" }}
                            onClick={() => history.push(`/aepsinvoice/${record.transactionId}`)}
                        />
                    </Tooltip>
                </Space>
            )
        },
        {
            name: 'Message',
            selector: row => <Tooltip placement="bottom" title={row.message}>{row.message}</Tooltip>,
            width: "200px",
            headerStyle: () => ({ textAlign: "center" }),
        }
    ];

    const transactionInquiry = (data) => {
        setLoading(true);
        const payload = { transactionId: data.transactionId };
        const URL = FING_PAY_CASH_DEPOSIT_STATUS_API;
        postRequest(`${URL}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    toast.success(response.message);
                } else {
                    toast.error(response.message || 'Inquiry failed');
                }
                getDataReports();
            })
            .catch((error) => {
                console.error(error);
                toast.error('Network error during inquiry');
                getDataReports();
            })
            .finally(() => setLoading(false));
    };

    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    };

    const getDataReports = (data) => {
        setLoading(true);
        const params = { page, limit: isLimit };
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        params.searchTransId = searchTransId || "";
        params.searchMobile = searchMobile || "";
        params.searchServiceName = "Cash Deposit";
        params.searchAadhar = searchAadhar || "";

        const queryString = objectToQueryString(params);
        getRequest(`${GET_AEPS_HISTORY_LIST}?${queryString}`, history)
            .then((response) => {
                if (response.success === true) {
                    setData(response.data);
                    setTotalRecord(response.data.totalDocs);
                    setPage(response.data.page);
                } else {
                    toast.error(response.message || 'Failed to fetch data');
                    setData([]);
                    setTotalRecord(0);
                    setPage(1);
                }
            })
            .catch((error) => {
                console.error(error);
                toast.error('Network error or server error');
                setData([]);
                setTotalRecord(0);
                setPage(1);
            })
            .finally(() => setLoading(false));
    };

    const handlePageChange = (page) => setPage(page);

    const onChangeStartDate = (date) => setStartDate(date);
    const onChangeEndDate = (date) => setEndDate(date);

    const handleSearch = () => getDataReports();

    const handleClear = () => {
        setSearchAadhar('');
        setSearchTransId('');
        setSearchMobile('');
        setStartDate('');
        setEndDate('');
    };

    useEffect(() => {
        getDataReports();
    }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

    if (isLoading) {
        return (
            <div className="content text-center" style={{ margin: "250px 0" }}>
                <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
            </div>
        );
    }

    return (
        <div>
            <div className="row">
                <div className='col-md-12 date-search mb-0'>
                    <div className='row'>
                        <div className='col-md-2 col-lg-2'>
                            <div className="form-group">
                                <label className='date-search-label mb-0 text-blue'>From</label>
                                <DatePicker className="form-control form-control-border" value={startDate} format={dateFormat} onChange={onChangeStartDate} />
                            </div>
                        </div>
                        <div className='col-md-2 col-lg-2'>
                            <div className="form-group">
                                <label className='date-search-label mb-0 text-red'>To</label>
                                <DatePicker className="form-control form-control-border" value={endDate} format={dateFormat} onChange={onChangeEndDate} />
                            </div>
                        </div>
                        <div className='col-md-3 col-lg-3 d-flex'>
                            <div className="form-group mr-3">
                                <label className='date-search-label mb-0 text-red'></label>
                                <input type="text" className="form-control form-control-border" placeholder="Aadhar Number" onChange={(e) => setSearchAadhar(e.target.value)} value={searchAadhar} />
                            </div>
                            <div className="form-group">
                                <label className='date-search-label mb-0 text-red'></label>
                                <input type="text" className="form-control form-control-border" placeholder="Trans ID" onChange={(e) => setSearchTransId(e.target.value)} value={searchTransId} />
                            </div>
                        </div>
                        <div className='col-md-3 col-lg-3 d-flex'>
                            <div className="form-group mr-3">
                                <label className='date-search-label mb-0 text-red'></label>
                                <input type="text" className="form-control form-control-border" placeholder="Mobile Number" onChange={(e) => setSearchMobile(e.target.value)} value={searchMobile} />
                            </div>
                        </div>
                        <div className='col-md-4 col-lg-1'>
                            <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                            <button type="submit" className="btn btn-primary rounded-pill pl-4 pr-4" onClick={handleSearch}>Search</button>
                        </div>
                        <div className='col-md-4 col-lg-1'>
                            <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                            <button type="button" className="btn btn-default rounded-pill ml-3 pl-4 pr-4 pull-right" onClick={handleClear}>Reset</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid pt-2 pb-5">
                <DataTable
                    title={""}
                    columns={columns}
                    data={getData.docs}
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={getTotalRecord}
                    onChangeRowsPerPage={getDataReports}
                    onChangePage={handlePageChange}
                />
            </div>
        </div>
    );
}

export default CashDepositHistory;